import React, { useEffect, useState } from 'react';
import { Empty } from 'antd';
import Profiles from './Profiles';
import styles from './index.module.less';
import profilePhoto from './images/Simplification.png';

export default function ProfileData({ list_data, onProfileAction, tabActive }) {
  // console.log('list_data', list_data);

  useEffect(() => {}, [list_data]);

  // Map list_data to match the expected keys for Profiles
  const transformedData = list_data?.flatMap((item) => {
    return item.Profiles.map((profile) => ({
      pic:
        profile.ProfileImages.length > 0
          ? profile.ProfileImages[0].objectKey
          : profilePhoto,
      // code: item.user_name || '',
      code: item?.profile_unique_id || '',
      name: profile?.profile_name || '',
      dob: profile?.calculated_age ? `${profile?.calculated_age} yrs` : '',
      // height: `${profile.height_ft || ''}' ${profile.height_in || ''}"`,
      height: profile?.height_cms ? `${profile.height_cms} cm` : '',
      marriedStatus: profile?.MaritalStatus?.marital_status, // Add if available in your data
      address: profile.City?.city || '',
      occupation: profile.employed_in || '',
      education:
        profile.ProfileEducations.map(
          (edu) => edu.HigherEducation.education
        ).join(', ') || '',
      // income: profile.annual_income || '',
      income: profile.annual_income
        ? Number(profile.annual_income).toLocaleString()
        : '',
      isNew: item?.is_new, // Assuming a default value
      isFavourite: profile.is_favourite, // Assuming a default value
      id: item.id,
      profile_id: profile.id
    }));
  });

  const transformedData1 = list_data?.flatMap((item) => {
    return item.Profiles.map((profile) => ({
      pic:
        profile.ProfileImages.length > 0
          ? profile.ProfileImages[0].objectKey
          : profilePhoto,
      // code: item.user_name || '',
      code: item?.profile_unique_id || '',
      name: profile?.profile_name || '',
      dob: profile?.calculated_age ? `${profile?.calculated_age} yrs` : '',
      // height: `${profile.height_ft || ''}' ${profile.height_in || ''}"`,
      height: profile?.height_cms ? `${profile.height_cms} cm` : '',
      marriedStatus: profile?.MaritalStatus?.marital_status, // Add if available in your data
      address: profile.City?.city || '',
      occupation: profile.employed_in || '',
      education:
        profile.ProfileEducations.map(
          (edu) => edu.HigherEducation.education
        ).join(', ') || '',
      // income: profile.annual_income || '',
      income: profile.annual_income
        ? Number(profile.annual_income).toLocaleString()
        : '',
      isNew: item?.is_new, // Assuming a default value
      isFavourite: profile.is_favourite, // Assuming a default value
      id: item.id,
      profile_id: profile.id
    }));
  });

  // const [activeTab, setActiveTab] = useState('4');
  const [selectedTab, setselectedTab] = useState('3');
  useEffect(() => {
    tabActive(selectedTab);
  }, [selectedTab]);

  const handleShortList = (tabId) => {
    console.log(' shortlist entered');
    // setselectedTab('8');
    setselectedTab(tabId);
    // tabActive(selectedTab);
  };
  console.log('activeTab', selectedTab);
  // console.log('transformedData', transformedData);
  return (
    <div className={styles.requst}>
      <div className={styles.liket}>
        <div className={styles.likeCon}>
          <span
            className={`
               ${selectedTab === '3' ? styles.activeTab : styles.remainingTab}`}
            onClick={() => setselectedTab('3')}
          >
            Sent
          </span>
          <span
            className={`
              ${selectedTab === '8' ? styles.activeTab : styles.remainingTab}`}
            // onClick={handleShortList}
            onClick={() => handleShortList('8')}
          >
            Received
          </span>
          <span
            className={`
              ${selectedTab === '11' ? styles.activeTab : styles.remainingTab}`}
            onClick={() => handleShortList('11')}
          >
            Approved
          </span>
          <span
            className={`
              ${selectedTab === '12' ? styles.activeTab : styles.remainingTab}`}
            onClick={() => handleShortList('12')}
          >
            Rejected
          </span>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%'
        }}
      >
        <div
          style={{
            paddingTop: '15px',
            paddingBottom: '30px'
          }}
        >
          {/* <div className={styles.liket}>
          <span
            className={`
             
               ${selectedTab === '3' ? styles.activeTab : styles.remainingTab}`}
            onClick={() => setselectedTab('3')}
          >
            Sent
          </span>
          <span
            className={`
               
              ${selectedTab === '8' ? styles.activeTab : styles.remainingTab}`}
            onClick={handleShortList}
          >
            Received
          </span>
        </div> */}
          {/* {transformedData?.length > 0 ? (
          <div className={styles.profilegrid}>
            {transformedData?.map((partner, index) => (
              <Profiles
                key={partner.code || index}
                data={partner}
                onProfileAction={onProfileAction}
              />
            ))}
          </div>
        ) : (
          <Empty
            description="No profiles available"
            className={styles.emptydashboard}
          />
        )} */}
          <div style={{ display: selectedTab === '3' ? 'block' : 'none' }}>
            {transformedData?.length > 0 ? (
              <div className={styles.profilegrid}>
                {transformedData?.map((partner, index) => (
                  <Profiles
                    key={partner.code || index}
                    data={partner}
                    // onProfileAction={onProfileAction}
                    onProfileAction={
                      (profileId, actionType, sourceType) =>
                        onProfileAction(
                          profileId,
                          actionType,
                          sourceType,
                          selectedTab
                        ) // Pass selectedTab
                    }
                  />
                ))}
              </div>
            ) : (
              <Empty
                description="No profiles available"
                className={styles.emptydashboard}
              />
            )}
          </div>
          <div style={{ display: selectedTab === '8' ? 'block' : 'none' }}>
            {transformedData1?.length > 0 ? (
              <div className={styles.profilegrid}>
                {transformedData1?.map((partner, index) => (
                  <Profiles
                    key={partner.code || index}
                    data={partner}
                    // onProfileAction={onProfileAction}
                    onProfileAction={
                      (profileId, actionType, sourceType) =>
                        onProfileAction(
                          profileId,
                          actionType,
                          sourceType,
                          selectedTab
                        ) // Pass selectedTab
                    }
                  />
                ))}
              </div>
            ) : (
              <Empty
                description="No profiles available"
                className={styles.emptydashboard}
              />
            )}
          </div>

          {/*  */}
          <div style={{ display: selectedTab === '11' ? 'block' : 'none' }}>
            {transformedData1?.length > 0 ? (
              <div className={styles.profilegrid}>
                {transformedData1?.map((partner, index) => (
                  <Profiles
                    key={partner.code || index}
                    data={partner}
                    // onProfileAction={onProfileAction}
                    onProfileAction={
                      (profileId, actionType, sourceType) =>
                        onProfileAction(
                          profileId,
                          actionType,
                          sourceType,
                          selectedTab
                        ) // Pass selectedTab
                    }
                  />
                ))}
              </div>
            ) : (
              <Empty
                description="No profiles available"
                className={styles.emptydashboard}
              />
            )}
          </div>
          {/* 12 */}
          <div style={{ display: selectedTab === '12' ? 'block' : 'none' }}>
            {transformedData1?.length > 0 ? (
              <div className={styles.profilegrid}>
                {transformedData1?.map((partner, index) => (
                  <Profiles
                    key={partner.code || index}
                    data={partner}
                    // onProfileAction={onProfileAction}
                    onProfileAction={
                      (profileId, actionType, sourceType) =>
                        onProfileAction(
                          profileId,
                          actionType,
                          sourceType,
                          selectedTab
                        ) // Pass selectedTab
                    }
                  />
                ))}
              </div>
            ) : (
              <Empty
                description="No profiles available"
                className={styles.emptydashboard}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
